import { useAppSelector } from '@brands/hooks/useReduxHook';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { useMemo } from 'react';
import { To, useNavigate } from 'react-router-dom';

const ABSOLUTE_ROUTE_ROOTS = ['admin', 'collector', 'careadvisor'];
const USER_ROLES_LOWER = Object.values(UserRoleName).map((r) => r.toLowerCase());

const getFirstPathSegment = (path: string): string | null => {
  if (!path) return null;

  return path.split('?')[0].split('#')[0].split('/').filter(Boolean)[0]?.toLowerCase() ?? null;
};

export default function useRoleNavigate() {
  const navigate = useNavigate();
  const { userInfo } = useAppSelector(selectAuth);
  const role = userInfo?.role?.name;

  return useMemo(() => {
    return (to: To | number, options?: { replace?: boolean; state?: any }) => {
      if (typeof to === 'string') {
        const firstSegment = getFirstPathSegment(to);

        const hasRoleInUrl = firstSegment != null && USER_ROLES_LOWER.includes(firstSegment);
        const isAbsoluteAppRoute = firstSegment != null && ABSOLUTE_ROUTE_ROOTS.includes(firstSegment);

        if (!hasRoleInUrl && !isAbsoluteAppRoute) {
          to = `/${role.toLowerCase()}${to.startsWith('/') ? '' : '/'}${to}`;
        }

        navigate(to, options);
      } else if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(to, options);
      }
    };
  }, [navigate, role]);
}
